angular.module('iqxCore')
.controller('ContactsCtrl', function ($scope, $q, FormSvc) {
  FormSvc.setOptions($scope,{
      fetchAPI:'callresult/NetContactList',
      multiRow:true
      })
      
  $scope.editContact=function(contact, isNew) {
    var newContact
    if (isNew){
      newContact={}
      newContact.BaseEmploymentID=contact.EmploymentID
      newContact.EmploymentID='NEW'
      newContact.Department=contact.Department
      contact=undefined  // Ensures ALL fields are included in the post data
    } else {
      newContact=angular.copy(contact) // Make copy to avoid trashing original in case of cancel
    }
    return FormSvc.modalForm($scope,'contactEdit',newContact,'md',{label:'col-sm-3', data:'col-sm-7'})
    .then(function(dat) {
      dat=FormSvc.saveableRecord(dat,'p','EmploymentID',contact)
      if (!dat) {FormSvc.alert("Notice", "Nothing to save.", "info"); return $q.reject('')} // Nothing to save
      return $scope.exec('call/NetContactSet',dat)
      })
    .then(function() {
      if (isNew) {
        FormSvc.alert("Updated", "Contact added successfully.", "success")
      } else {
        FormSvc.alert("Updated", "Contact updated successfully.", "success")
      }      
      return $scope.fetch()
      })
  }
  
  $scope.editRights=function(contact) {
    $scope.fetch({fetchAPI:'callresult/NetContactRights?pEmploymentID='+contact.EmploymentID, 
                  fetchTarget:'contactRights',
                  multiRow:true})   
    .then(function(){
      var dat={PersonName:contact.PersonName,rights:$scope.contactRights}
      return FormSvc.modalForm($scope,'contactRights',dat,'md')
      })
    .then(function(dat){
      var rightsList = [];
      angular.forEach(dat.rights,function(rt){
        rightsList.push('Right_'+rt.RightID+'='+rt.RightAssignedLabel)
        })
      return $scope.exec('call/NetContactRightsSet',{pEmploymentID:contact.EmploymentID,pRightsList:rightsList.join()})
      })
    .then(function(){
      FormSvc.alert("Updated", "Contact permissions updated successfully.", "success")
    })
  }
  
  $scope.addContact=function(){
    var dat={contactList:$scope.theRecords, selected:''}
    FormSvc.modalForm($scope,'contactTemplateSelector',dat,'md')
    .then(function(){
      var tpl
      angular.forEach($scope.theRecords,function(it){
        if (it.EmploymentID==dat.selected) {tpl=it}
        })
      if (tpl){
        $scope.editContact(tpl,true)
      }
    })
  }
  
  $scope.fetch()

  })
